import type { ErrorInfo } from "react";

import { AwsRum, type AwsRumConfig } from "aws-rum-web";

// Global instance of CloudWatch RUM. Should always be defined after initRUM is successfully called
export let rumInstance: AwsRum | null = null;

const APPLICATION_REGION: string = "eu-west-2";

const config: AwsRumConfig = {
  sessionSampleRate: 1,
  endpoint: "https://dataplane.rum.eu-west-2.amazonaws.com",
  telemetries: ["performance", "errors", "http"],
  allowCookies: true,
  enableXRay: false,
  signing: false,
};

export const initRUM = () => {
  try {
    const APPLICATION_ID = import.meta.env.VITE_APPLICATION_ID;

    if (!APPLICATION_ID) {
      console.warn("No application ID found. Cloudwatch not initialized");
      return;
    }

    rumInstance = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config,
    );
  } catch {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
};

export const logError = (error: unknown, _info?: ErrorInfo) => {
  if (rumInstance)
    rumInstance.recordError(
      error instanceof Error ? error : new Error(String(error)),
    );
};
